import React from 'react'

export default ({ ...props }) => (
  <svg {...props} width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='16' cy='16' r='15.5' stroke='#27F2B9' />
    <path
      d='M12.6111 22.9978C12.5133 22.9978 12.4156 22.9772 12.3263 22.9361C12.1259 22.8429 12 22.6577 12 22.4573V10.541C12 10.3395 12.1259 10.1553 12.3263 10.0621C12.5268 9.96898 12.77 9.98089 12.957 10.0957L22.7348 16.0539C22.901 16.1546 23 16.3215 23 16.5002C23 16.6789 22.901 16.8458 22.7348 16.9465L12.957 22.9047C12.8531 22.9675 12.7321 23 12.6111 23V22.9978Z'
      fill='white'
    />
  </svg>
)
